import { FunctionComponent } from 'react'

import { Container } from '../components/Container'

import { VisualizationComponentProps } from '../types'

import { StackVisualizationItem } from './StackVisualizationItem'

export const Stack: FunctionComponent<VisualizationComponentProps> = ({
  items,
  benchmark,
  isLegendVisible,
  isScoreBy10,
  legend,
  isGaps,
}) => (
  <Container
    benchmark={benchmark}
    isLegendVisible={isLegendVisible}
    legend={legend}
    items={items}
  >
    {items.map(item => (
      <StackVisualizationItem
        key={item.label}
        item={item}
        isScoreBy10={isScoreBy10}
        isGaps={isGaps}
      />
    ))}
  </Container>
)
